import component from './component.vue';

export default {
  install(Vue, { router }) {
    router.addRoutes([
      {
        path: '/tour',
        props: true,
        component,
        children: [
          {
            path: '/',
            component: () => import('./List.vue'),
            props: true,
          },
          {
            path: ':id',
            component: () => import('./Item.vue'),
            props: true,
          },
        ],
      },
    ]);
  },
};
